import type { AddItemContext, CartStateGetSet } from "@/cart/types";
import { MATIC_CARE_VARIANT_ID } from "@/consts/shopify";

export const addMaticCare = ({ get }: CartStateGetSet) => {
  return async (context?: AddItemContext, quantity?: number) => {
    await get().addItem(MATIC_CARE_VARIANT_ID, context, quantity ?? 1);
    return get().cart;
  };
};
